import { render, staticRenderFns } from "./RelatorioFaturamentoEtapas.vue?vue&type=template&id=2628b202"
import script from "./RelatorioFaturamentoEtapas.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoEtapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports